export default __webpack_public_path__ + "static/media/SA.0473f062.svg";